import type { Component } from "solid-js";
import { twMerge } from "tailwind-merge";

export const ProgressBar: Component<{ percentage: number }> = (props) => {
	const clampedPercentage = () => Math.min(Math.max(props.percentage, 0), 100);

	return (
		<div class="relative h-2 w-full">
			<div class="absolute inset-0 rounded-full bg-interaction-grey-light" />
			<div
				class={twMerge(
					"absolute top-0 left-0 h-2 rounded-full bg-interaction-violet",
					clampedPercentage() <= 10 && "bg-status-accent-error"
				)}
				style={{ width: `${clampedPercentage()}%` }}
			/>
		</div>
	);
};
